module.exports = __webpack_public_path__ + "img/icon_transfer.b8fed8bf.png";